import React from 'react';
import { GiSpellBook } from 'react-icons/gi';
import './Banner.scss';

export default function Banner() {
  const items = [...Array(10)].map((u, i) => `${i + 1}`);
  return (
    <div
      className="circles-container"
    >
      <div
        className="circles"
      >
        {items.map(item => (
          <GiSpellBook key={`banner-animation-${item}`} className="item" />
        ))}
      </div>
    </div>
  );
}
